/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function SplitVerticalIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "split-vertical", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 5.5, y: 5.5, width: 14, height: 14, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 5.5V19.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(SplitVerticalIcon);
export default ForwardRef;
//# sourceMappingURL=splitVerticalIcon.js.map